// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		itemsMenu.forEach((itemMenu)=>{
			if(itemMenu.querySelector('.submenu')){
				itemMenu.addEventListener('mouseenter',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
				});
				itemMenu.addEventListener('mouseleave',()=>{
					itemMenu.classList.remove('hover');
					itemMenu.querySelector('.submenu').classList.remove('show');
				})
			}
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(document.querySelector('.courses-home')){
		let title = document.querySelector('.courses-home .title h2').offsetHeight + 65;
		document.querySelector('.bg-div').style.height = title+'px';
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

	
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if (document.querySelector('.form-module-wrapper')) {
        document.querySelectorAll('.form-module-wrapper').forEach((item) => {
            item.classList.add('animate-fade', 'top');
        });
    }

	if (document.querySelector('.text-modules-wrapper')) {
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item) => {
            item.classList.add('animate-fade', 'top');
        });
    }

	if (document.querySelector('.global-sitemap')) {
        document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
    }

	/*MOBILE MENU NAV
	****************************************************************/
    let MenuBtn = document.querySelector('.js-open-menu');
    let CloseMenu = document.querySelector('.close-menu');
    let Navigation = document.querySelectorAll('.menu-mobile');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Navigation[0].classList.add('show');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
			document.querySelector('.item-open > a').classList.add('active');
            inner.closest('.sub-sub-menu').classList.add('menu-open');;
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu){
        CloseMenu.addEventListener('click', function(e){
            Navigation[0].classList.remove('show');
        });
    }

    	//open booking widget
	let bookingCtas = document.querySelectorAll('.js-bookingcta');
	let bookingBlock = document.getElementsByClassName('booking-block-js')[0];
	let bookingClose = document.getElementsByClassName('close-js')[0];

    if(bookingCtas){
        bookingCtas.forEach((bookingCta)=>{
            bookingCta.addEventListener('click', (e)=>{
                e.preventDefault();
                bookingBlock.classList.add('open');
            });
            bookingClose.addEventListener('click', function(){
                bookingBlock.classList.remove('open');
            });
        })
    }


	var data = document.URL;

	if(data.indexOf("?course=") != -1 && document.querySelector('.courses-list')){
		let dataFilter = data.split('?course=')[1];
		let target = document.getElementById(dataFilter);
		let headerHeight = document.querySelector('header').offsetHeight;

		window.scrollTo({
			top: target.offsetTop - headerHeight,
			behavior: 'smooth'
		});
	}

	
})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}